module.exports = __webpack_public_path__ + "img/univ_2n6.c6eba805.png";